export enum CreditorApproval {
  GET_CREDITORS_LIST_FOR_APPROVAL = "GET_CREDITORS_LIST_FOR_APPROVAL",
  GET_CREDITORS_LIST_FOR_APPROVAL_SUCCESS = "GET_CREDITORS_LIST_FOR_APPROVAL_SUCCESS",
  GET_CREDITORS_LIST_FOR_APPROVAL_FAIL = "GET_CREDITORS_LIST_FOR_APPROVAL_FAIL",

  APPROVE_CREDITOR = "APPROVE_CREDITOR",
  APPROVE_CREDITOR_SUCCESS = "APPROVE_CREDITOR_SUCCESS",
  APPROVE_CREDITOR_FAIL = "APPROVE_CREDITOR_FAIL",
}
